import { components } from "@certn/api/generated-schemas/client-portal";

import { SelectedChecksType } from "../pages/order/OrderContext";

export function getSelectedUmbrellaOptions(
  check: SelectedChecksType
): components["schemas"]["UmbrellaCheckSelectOption"][] {
  return check.selected_options ?? check.selectedOptions ?? [];
}
